import { render, staticRenderFns } from "./sendTestCardConfirm.vue?vue&type=template&id=d173f696&scoped=true"
import script from "./sendTestCardConfirm.vue?vue&type=script&lang=js"
export * from "./sendTestCardConfirm.vue?vue&type=script&lang=js"
import style0 from "./sendTestCardConfirm.vue?vue&type=style&index=0&id=d173f696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d173f696",
  null
  
)

export default component.exports